function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { PixelFetch } from '../pixel-fetch';
import { sdkLogger } from '../../../logger';
import { AdBreakType, AdMetadataSource, AdStreamType, SsaiStitcherType } from '../common';
/**
 * Raised at a time where a non-linear frame ad may be shown
 * We only currently expect the companion ad to be of the
 * 'Frame ad' template type but there is planned work to
 * add more (i.e. 'Marquee ad variant')
 * @public
 */ export var CompanionAdvertDispatcher = /*#__PURE__*/ function() {
    "use strict";
    function CompanionAdvertDispatcher(sessionController) {
        var disableCompanionAdsWhenCaptionEnabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, pixelFetch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new PixelFetch(self);
        _class_call_check(this, CompanionAdvertDispatcher);
        _define_property(this, "sessionController", void 0);
        _define_property(this, "disableCompanionAdsWhenCaptionEnabled", void 0);
        _define_property(this, "pixelFetch", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "encounteredAdIds", void 0);
        _define_property(this, "consumedAdStartedIds", void 0);
        _define_property(this, "consumedAdEndedIds", void 0);
        _define_property(this, "notifiedAdStartedIds", void 0);
        _define_property(this, "notifiedAdEndedIds", void 0);
        _define_property(this, "scheduledCompanionAdOpportunityEvents", void 0);
        _define_property(this, "currentTimeSeconds", void 0);
        _define_property(this, "isCompanionAdsDispatchEnabled", void 0);
        this.sessionController = sessionController;
        this.disableCompanionAdsWhenCaptionEnabled = disableCompanionAdsWhenCaptionEnabled;
        this.pixelFetch = pixelFetch;
        this.logger = sdkLogger.withContext('CompanionAdvertDispatcher');
        this.encounteredAdIds = new Set();
        this.consumedAdStartedIds = new Set();
        this.consumedAdEndedIds = new Set();
        this.notifiedAdStartedIds = new Set();
        this.notifiedAdEndedIds = new Set();
        this.scheduledCompanionAdOpportunityEvents = new Map();
        this.currentTimeSeconds = 0;
        this.isCompanionAdsDispatchEnabled = true;
        this.listenToSessionEvents();
    }
    _create_class(CompanionAdvertDispatcher, [
        {
            key: "addAdEventsFromAdData",
            value: function addAdEventsFromAdData(ads) {
                var _this = this;
                if (!this.isCompanionAdsDispatchEnabled) {
                    this.logger.info('Companion Ad opportunity encountered but ignored because captions have been enabled');
                    return;
                }
                if (!ads) {
                    return this.logger.error("Malformed nonLinear ads data received, expected array of Companion ads but received", ads);
                }
                ads.filter(function(nonLinearAd) {
                    return _this.isValidCompanionAd(nonLinearAd) && !_this.adAlreadyEncountered(nonLinearAd.variants[0].adId);
                }).forEach(function(companionAd) {
                    var _companionAd_variants = _sliced_to_array(// frame ads only have 1 variant
                    companionAd.variants, 1), data = _companionAd_variants[0];
                    var adId = data.adId, durationInSeconds = data.durationInSeconds, startTimeInSeconds = data.startTimeInSeconds, companionAdTemplateType = data.companionAdTemplateType;
                    // malformed opportunity received, do not raise as an opportunity and skip any initialisation of beacons
                    if (!companionAdTemplateType) {
                        return _this.logger.error("Malformed ad opportunity received from SSAI tracking call: an companion ad template type is expected but got ".concat(companionAdTemplateType, ", this opportunity with id ").concat(adId, " will be ignored and no no reporting beacons will be fired"), adId);
                    }
                    var adBreakReportingData = _this.buildAdReportingData(data);
                    var endOpportunityTimeInSeconds = startTimeInSeconds + durationInSeconds;
                    var uniqueAdIdWithTime = _this.generateAdIdWithTimeInSecondsLabel(adId, startTimeInSeconds);
                    _this.logger.info("".concat(companionAdTemplateType, " Ad opportunity received, scheduling notifications for [start, end] of opportunity"), adId, "[".concat(startTimeInSeconds, ", ").concat(endOpportunityTimeInSeconds, "]"), "-- current time: ".concat(_this.currentTimeSeconds, " seconds --"));
                    // record encountered opportunity by id to ensure we handle edge case of duplicates
                    _this.encounteredAdIds.add(adId);
                    _this.scheduledCompanionAdOpportunityEvents.set(uniqueAdIdWithTime, {
                        startTime: startTimeInSeconds,
                        endTime: endOpportunityTimeInSeconds,
                        signalAdOpportunityStarted: _this.signalAdOpportunityStarted.bind(_this, uniqueAdIdWithTime, companionAd, adBreakReportingData),
                        signalAdOpportunityEnded: _this.signalAdOpportunityEnded.bind(_this, uniqueAdIdWithTime, companionAd, adBreakReportingData)
                    });
                });
            }
        },
        {
            key: "generateAdIdWithTimeInSecondsLabel",
            value: function generateAdIdWithTimeInSecondsLabel(adId, startTimeInSeconds) {
                return "".concat(adId, "_").concat(startTimeInSeconds);
            }
        },
        {
            key: "logFrameAdIgnoreDuplicateReportingBeacon",
            value: function logFrameAdIgnoreDuplicateReportingBeacon(consumedContext, adId, readableCompanionAdType, context) {
                var hasBeenEncountered = consumedContext.has(adId);
                if (!hasBeenEncountered) {
                    return false;
                }
                this.logger.warn("[ ".concat(readableCompanionAdType, " ").concat(context, " ]: Duplicate ").concat(readableCompanionAdType, " Ad (adId: ").concat(adId, ") encountered"));
                return true;
            }
        },
        {
            key: "isValidCompanionAd",
            value: function isValidCompanionAd(nonLinearAd) {
                if (!nonLinearAd) {
                    this.logger.verbose('Expected companion ad data but instead got', nonLinearAd);
                    return false;
                }
                if (!nonLinearAd.hasOwnProperty('variants')) {
                    this.logger.verbose('Expected companion ad data to contain a variant property but none was found', nonLinearAd.variants);
                    return false;
                }
                if (!nonLinearAd.variants || !nonLinearAd.variants.length) {
                    this.logger.verbose('Expected companion ad variant data to be an array of variants but instead got', nonLinearAd.variants);
                    return false;
                }
                if (!nonLinearAd.variants[0].hasOwnProperty('adId')) {
                    this.logger.verbose('Expected companion ad variant data array to contain a variant element with an "adId" property but none was found', nonLinearAd.variants);
                    return false;
                }
                if (!nonLinearAd.variants[0].adId) {
                    this.logger.verbose('Expected companion ad variant data to contain a variant element with a valid "adId" property but but found adId is', nonLinearAd.variants[0].adId);
                    return false;
                }
                return true;
            }
        },
        {
            key: "adAlreadyEncountered",
            value: function adAlreadyEncountered(adId) {
                var alreadyEncountered = this.encounteredAdIds.has(adId);
                if (!alreadyEncountered) {
                    this.logger.info("NEW Ad opportunity encountered", adId, "[current time in seconds: ".concat(this.currentTimeSeconds, "]"));
                }
                return alreadyEncountered;
            }
        },
        {
            key: "listenToSessionEvents",
            value: function listenToSessionEvents() {
                var _this = this;
                this.sessionController.onSubtitlesTrackChanged(function(track) {
                    if (_this.disableCompanionAdsWhenCaptionEnabled && track && track.id) {
                        _this.isCompanionAdsDispatchEnabled = false;
                    } else {
                        _this.isCompanionAdsDispatchEnabled = true;
                    }
                });
                this.sessionController.onPlaybackTimelineUpdated(function(_timeline, currentTimeSeconds) {
                    _this.currentTimeSeconds = currentTimeSeconds;
                    // check if there are any encountered ad opportunities in our collection
                    if (_this.scheduledCompanionAdOpportunityEvents.size < 1 || !currentTimeSeconds) {
                        return;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        /**
             * - iterate through companion ad opportunity collection
             * - (key is the scheduled time of start time + duration)
             * - IF they exceed current time
             *   - notify subscribers that the ad opportunity has started/ended
             *   - delete the scheduled signal to avoid duplicate notifications of the event
             */ for(var _iterator = _this.scheduledCompanionAdOpportunityEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var companionAd = _step.value;
                            var _companionAd = _sliced_to_array(companionAd, 2), uniqueAdId = _companionAd[0], _companionAd_ = _companionAd[1], startTime = _companionAd_.startTime, endTime = _companionAd_.endTime, signalAdOpportunityStarted = _companionAd_.signalAdOpportunityStarted, signalAdOpportunityEnded = _companionAd_.signalAdOpportunityEnded;
                            // only notify if within the ad opportunity range and if this specified opportunity starting has not already been signalled
                            if (currentTimeSeconds >= startTime && currentTimeSeconds < endTime && !_this.notifiedAdStartedIds.has(uniqueAdId)) {
                                _this.logger.info('frame notifySTART @', currentTimeSeconds, "[startTime, endTime]: [".concat(startTime, ", ").concat(endTime, "]"), uniqueAdId, _this.notifiedAdStartedIds);
                                signalAdOpportunityStarted();
                            }
                            // only notify if if outside of ad opportunity range, start signal had been made and has not been already notified of the end signal
                            if (currentTimeSeconds >= endTime && _this.notifiedAdStartedIds.has(uniqueAdId) && !_this.notifiedAdEndedIds.has(uniqueAdId)) {
                                _this.logger.info('frame notifyEND @', currentTimeSeconds, "[startTime, endTime]: [".concat(startTime, ", ").concat(endTime, "]"), uniqueAdId, _this.notifiedAdStartedIds);
                                signalAdOpportunityEnded();
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            key: "signalAdOpportunityStarted",
            value: function signalAdOpportunityStarted(uniqueAdId, companionAdData, adBreakReportingData) {
                var _this = this;
                var adStartedBeacons = companionAdData.adStartedBeacons, adFinishedBeacons = companionAdData.adFinishedBeacons, _companionAdData_variants = _sliced_to_array(companionAdData.variants, 1), data = _companionAdData_variants[0];
                var companionAdTemplateType = data.companionAdTemplateType, startTimeInSeconds = data.startTimeInSeconds;
                this.logger.info("".concat(companionAdTemplateType, " Ad opportunity started, notifying subscribers"), uniqueAdId, startTimeInSeconds, "[current time in seconds: ".concat(this.currentTimeSeconds, "]"));
                this.notifiedAdStartedIds.add(uniqueAdId);
                this.sessionController.notifyAdBreakStarted(adBreakReportingData);
                this.sessionController.notifyAdStarted(adBreakReportingData.ads[0]);
                this.sessionController.notifyCompanionAdOpportunityStarted({
                    data: data,
                    companionAdDidStart: function() {
                        if (_this.logFrameAdIgnoreDuplicateReportingBeacon(_this.consumedAdStartedIds, uniqueAdId, companionAdTemplateType, 'Ad Started')) {
                            return;
                        }
                        adStartedBeacons.forEach(function(beacon) {
                            return _this.pixelFetch.fetch(beacon);
                        });
                        _this.consumedAdStartedIds.add(uniqueAdId);
                        _this.logger.info("".concat(companionAdTemplateType, " Ad started (adId: ").concat(uniqueAdId, "), impression beacon(s) sent"));
                    },
                    companionAdDidEnd: function() {
                        if (_this.logFrameAdIgnoreDuplicateReportingBeacon(_this.consumedAdEndedIds, uniqueAdId, companionAdTemplateType, 'Ad Ended')) {
                            return;
                        }
                        adFinishedBeacons.forEach(function(beacon) {
                            return _this.pixelFetch.fetch(beacon);
                        });
                        _this.consumedAdEndedIds.add(uniqueAdId);
                        _this.logger.info("".concat(companionAdTemplateType, " Ad ended (adId: ").concat(uniqueAdId, "), ending beacon(s) sent"));
                    }
                });
            }
        },
        {
            key: "signalAdOpportunityEnded",
            value: function signalAdOpportunityEnded(uniqueAdId, companionAdData, adBreakReportingData) {
                var _companionAdData_variants = _sliced_to_array(companionAdData.variants, 1), data = _companionAdData_variants[0];
                var adId = data.adId, companionAdTemplateType = data.companionAdTemplateType, durationInSeconds = data.durationInSeconds, startTimeInSeconds = data.startTimeInSeconds;
                this.logger.info("".concat(companionAdTemplateType, " Ad opportunity ended, notifying subscribers"), adId, startTimeInSeconds + durationInSeconds, "[current time in seconds: ".concat(this.currentTimeSeconds, "]"));
                this.notifiedAdEndedIds.add(uniqueAdId);
                this.sessionController.notifyAdFinished(adBreakReportingData.ads[0]);
                this.sessionController.notifyAdBreakFinished(adBreakReportingData);
                this.sessionController.notifyCompanionAdOpportunityEnded({
                    adId: adId,
                    companionAdTemplateType: companionAdTemplateType
                });
                this.scheduledCompanionAdOpportunityEvents.delete(uniqueAdId);
            }
        },
        {
            key: "buildAdReportingData",
            value: function buildAdReportingData(adData) {
                var adTitle = adData.adTitle, adCreativeId = adData.creativeId, durationInSeconds = adData.durationInSeconds, adInsights = adData.adInsights;
                var modifiedCreativeId = adInsights.creativeId ? 'fa:' + adInsights.creativeId : adCreativeId ? 'fa:' + adCreativeId : 'NA';
                var ad = {
                    id: adInsights.breakId || 'NA',
                    // adBreaks.id is used to ensure `breakId` is set in Ad Insights.
                    adBreakId: adInsights.breakId || 'NA',
                    creativeId: modifiedCreativeId,
                    // createId is the value suffixed with `fa:` to help differentiate it from regular ad types
                    name: adInsights.creativeName || adTitle,
                    expectedDuration: durationInSeconds,
                    advertiser: adInsights.advertiser || 'NA'
                };
                return {
                    id: adInsights.breakId || 'NA',
                    // adBreaks.id is used to ensure `breakId` is set in Ad Insights.
                    expectedDuration: durationInSeconds,
                    // the `ads` field is necessary for adBreak property because for reporting to be correct
                    // the ads array needs to be populated with at least one Ad-like element so that the `sequence`
                    // value can be calculated correctly as 1 for companion ads
                    ads: [
                        ad
                    ],
                    type: AdBreakType.Midroll,
                    watched: true,
                    streamType: AdStreamType.InStream,
                    ssaiStitcherType: SsaiStitcherType.MediaTailor,
                    metadataSource: AdMetadataSource.MediaTailor
                };
            }
        }
    ]);
    return CompanionAdvertDispatcher;
}();

//# sourceMappingURL=companion-advert-dispatcher.js.map